export interface RetryAffordance {
  canRetry: boolean
  retriesRemaining: number
  cooldownUntilMs: number | null
  reason: string | null
}

export interface GameRetryCardSelection {
  retry: RetryAffordance
  isErrored: boolean
}

export function selectGameRetryCard(input: {
  gameStatus?: string | null
  retry?: RetryAffordance | null
}): GameRetryCardSelection | null {
  const { gameStatus, retry } = input
  if (!retry)
    return null

  const isErrored = gameStatus === 'error'
  const isExhaustedInProgress
    = gameStatus === 'in_progress' && retry.reason === 'too_many_retries'

  if (!isErrored && !retry.canRetry && !isExhaustedInProgress)
    return null

  return { retry, isErrored }
}
